import { Section, eType, SectionInitData } from "../Section";
import { GameWorld, eGameObject as eWorldObject } from "../../GameWorld";
import { ParcelManager } from "../../../Parcel/ParcelManager";



/**
 * Stredova cast s vydejnou baliku
 */
export class ParcelCollection_1 extends Section {
    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super("collection_1", eType.parcelCollection_1, false);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    activate(z: number, initData?: SectionInitData): Section {
        super.activate(z, initData);

        // Vytvorit odberne misto
        ParcelManager.instance.addDispenser(z + this._size / 2, 1);

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected addObjectEntities(): void {
        let world = GameWorld.instance;

        // Zem
        let e = world.getObjectNewEntity(eWorldObject.ground_1);
        e.reparent(this._root);
        e.setLocalPosition(0, 0, 0);

        // Vydejna balicku
        e = world.getObjectNewEntity(eWorldObject.parcelCollection);
        e.setLocalPosition(-1.5, 0, 0);
        e.setEulerAngles(0, 0, 0);
        e.reparent(this._root);

        e = world.getObjectNewEntity(eWorldObject.parcelCollectionCarousel);
        e.reparent(this._root);
        e.setLocalPosition(-1, 0, 0);

        // Krabice
        e = world.getObjectNewEntity(eWorldObject.box);
        e.setEulerAngles(0, 0, 0);
        e.setLocalPosition(0.8, 0.035, -0.38);
        e.reparent(this._root);

        e = world.getObjectNewEntity(eWorldObject.box);
        e.setEulerAngles(0, 90, 0);
        e.setLocalPosition(1.22, 0.035, -0.38);
        e.reparent(this._root);

        // Paleta
        e = world.getObjectNewEntity(eWorldObject.pallet);
        e.setEulerAngles(0, 0, 0);
        e.setLocalPosition(1, 0.1, 0.3);
        e.reparent(this._root);

        // Strom
        e = world.getObjectNewEntity(eWorldObject.tree);
        e.setLocalPosition(-2.5, 0.04, 0);
        e.setLocalScale(1, 1, 1);
        e.reparent(this._root);
    }
}